define(function (require) {
  const es6MiddleUtils = require('src/es6MiddleUtils');
  const { Vue } = require('vue-infra');
  const Translator = es6MiddleUtils.removeEsModuleDefault(require("i18n/translator"));
  const LEConfig = require("assets/config/le-env-conf");
  const TranslatorPlugin = es6MiddleUtils.removeEsModuleDefault(require('src/components/plugins/TranslatorPlugin'));
  const PortalVue = es6MiddleUtils.removeEsModuleDefault(require('portal-vue'));
  const { VTooltip } = es6MiddleUtils.removeEsModuleDefault(require('lp-vue-components'));

  const modules = {};
  Vue.use(TranslatorPlugin, { Translator, useFallBackDicitionary: LEConfig.useFallBackDicitionary });

  // Since index.html on production is controlled somewhere else,
  // portal target element on top level is dynamically created
  let portalDiv = document.getElementById('fe-root-mounting-portal-target');
  if (!portalDiv){
    portalDiv = document.createElement('div');
    portalDiv.setAttribute('id', 'fe-root-mounting-portal-target');
    const body = document.getElementsByTagName('body') && document.getElementsByTagName('body')[0];
    if (body){
      body.appendChild(portalDiv);
    }
  }

  Vue.use(VTooltip, {
    defaultBoundariesElement: document.body,
  });

  Vue.use(PortalVue, {
    MountingPortalName: 'fe-root-mounting-portal'
  });
  return modules;
});
